
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';

export const useEditMode = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const { toast } = useToast();

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
    if (isEditMode) {
      toast({
        title: "Edit Mode Disabled",
        description: "Your dashboard changes have been saved",
      });
    } else {
      toast({
        title: "Edit Mode Enabled",
        description: "You can now customize your dashboard",
      });
    }
  };

  return {
    isEditMode,
    toggleEditMode,
  };
};
